export const SET_SHOULD_SCROLL_TO_ERROR = 'set-should-scroll-to-error';

export default function setShouldScrollToError() {
  return {
    type: SET_SHOULD_SCROLL_TO_ERROR,
  };
}
